import React, { createContext, useCallback, useState } from 'react'
import { IUser } from '@/interfaces/user'

type ChatSendMessageToastContextType = {
  isVisible: boolean
  selectedConnections: IUser[]
  onSelectConnection: (connection: IUser) => void
  onRemoveConnection: (connectionId: string) => void
  hideToast: () => void
  showToast: (initialSelectedConnections: IUser[]) => void
}

export const ChatSendMessageToastContext = createContext(
  {} as ChatSendMessageToastContextType
)

export const ChatSendMessageToastProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [selectedConnections, setSelectedConnections] = useState([])

  const showToast = useCallback((initialSelectedConnections: IUser[]) => {
    setSelectedConnections(initialSelectedConnections)
    setIsVisible(true)
  }, [])

  const hideToast = useCallback(() => {
    setIsVisible(false)
    setSelectedConnections([])
  }, [])

  const onSelectConnection = useCallback(
    (connection: IUser) => {
      setSelectedConnections([...selectedConnections, connection])
    },
    [selectedConnections]
  )

  const onRemoveConnection = useCallback(
    (userId: string) => {
      setSelectedConnections(selectedConnections.filter((c) => c.id !== userId))
    },
    [selectedConnections]
  )
  return (
    <ChatSendMessageToastContext.Provider
      value={{
        isVisible,
        selectedConnections,
        showToast,
        hideToast,
        onSelectConnection,
        onRemoveConnection,
      }}
    >
      {children}
    </ChatSendMessageToastContext.Provider>
  )
}
